import ccContext from '../cc-context';

const _caller = ccContext.reducer._caller;

export default _caller;
